module.exports = __webpack_public_path__ + "img/real_qmsat.6027dec2.jpg";